import { DataBox } from './DataBox'
import { baseMaintenanceTechnicianModel } from '../maintenanceTechnicianModel'
import { PageHeader } from './PageHeader'
import { AddMaintenanceTechnicianModal } from './addMaintenanceTechnicianModal'
import { EditMaintenanceTechnicianModal } from './editMaintenanceTechnicianModal'

export function BaseMaintenanceTechnician() {
    const { addCarVisible, editCarVisible } = baseMaintenanceTechnicianModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddMaintenanceTechnicianModal />}
            {editCarVisible && <EditMaintenanceTechnicianModal />}
        </>
    )
}
